import { useEffect } from "react";
import { MdFlashOn, MdPeople, MdSentimentSatisfied, MdTrendingUp } from "react-icons/md";
import StatCard from "components/stat-card";
import { track } from "lib/mixpanel";

/** Band a score so its meaning is carried by text as well as the icon tint. */
const scoreBand = (value, strong, fair) => {
  if (value >= strong) return { label: "Strong", accent: "sage" };
  if (value >= fair) return { label: "Fair", accent: "gold" };
  return { label: "Low", accent: "danger" };
};

const CheckInMetrics = ({ config, summary }) => {
  const { checkInViewed } = config.events;

  useEffect(() => {
    track(checkInViewed);
  }, [checkInViewed]);

  if (!summary) return null;

  const responseRate =
    summary.totalStaff > 0 ? Math.round((summary.responseCount / summary.totalStaff) * 100) : 0;
  const productivity = scoreBand(summary.productivityScore, 75, 50);
  const satisfaction = scoreBand(summary.avgSatisfaction, 4, 3);
  const contribution = scoreBand(summary.avgContribution, 4, 3);

  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      <StatCard
        icon={MdPeople}
        accent="sky"
        label="Responses"
        value={`${summary.responseCount}/${summary.totalStaff}`}
        caption={`${responseRate}% response rate`}
      />
      <StatCard
        icon={MdTrendingUp}
        accent={productivity.accent}
        label="Productivity"
        value={`${summary.productivityScore}`}
        caption={`out of 100 · ${productivity.label}`}
      />
      <StatCard
        icon={MdSentimentSatisfied}
        accent={satisfaction.accent}
        label="Satisfaction"
        value={(summary.avgSatisfaction || 0).toFixed(1)}
        caption={`out of 5.0 · ${satisfaction.label}`}
      />
      <StatCard
        icon={MdFlashOn}
        accent={contribution.accent}
        label="Contribution"
        value={(summary.avgContribution || 0).toFixed(1)}
        caption={`out of 5.0 · ${contribution.label}`}
      />
    </div>
  );
};

export default CheckInMetrics;
